import { Route } from 'react-router-dom';
import LandingNew from './Modules/LandingPageNew/LandingPageScreen';
import TnCScreen from './Modules/T&C';
import PropertyListing from './Modules/Properties/Listing';
import Profile from './Modules/Profile';
import PropertyDetails from './Modules/Properties/Details';
import PropertyCreate from './Modules/Properties/Create';
import PropertyEdit from './Modules/Properties/Edit';
import PropertyAddOtaListing from './Modules/Properties/AddOtaListing';
import React from 'react';
import { buildUrl } from './utils';
import Help from './Modules/Help';
import Earn from './Modules/Earn';
import FormScreenNew from './Modules/FormNew/FormScreenNew';
import { getClientSideCountryCode } from './utils/functionUtils';
import NotFoundScreen from './Modules/Error/NotFoundScreen';
import OyoSaathi from './Modules/OyoSaathi';
import PartnerProsperity from './Modules/Static/PartnerProsperity';
import Mission1000 from './Modules/Static/Mission1000';
import allCountriesData from './utils/country-code-mapping';
import Staycation from './Modules/Static/Staycation';
import Casestudies from './Modules/Static/Casestudies';
import Giveaway from './Modules/Static/Giveaway';
import Referral from './Modules/Static/Referral';
import PublicRoute from './common/PublicRoute';
import PrivateRoute from './common/PrivateRoute';

// there can be child routes. See PROPERTIES key for example. child routes should be in order of precedence
const pages = {
    LANDING: {
        key:1,
        route:"",
        queryValue:"landing",
        isPageCustom:false,
        isLoginRequired:false,
        component:LandingNew
    },
    PROPERTIES: {
        key:2,
        route:"properties",
        queryValue:"properties",
        isPageCustom:false,
        isLoginRequired:true,
        component:PropertyListing,
        childRoutes:[
            {
                route:'new/ota/:id',
                component:PropertyAddOtaListing
            },
            {
                route:"new",
                component: PropertyCreate,
            },
            {
                route:'edit/:id',
                component:PropertyEdit
            },
            {
                route:":id",
                component:PropertyDetails
            }
        ]
    },
    TNC:{
        key:3,
        route:"tnc",
        queryValue:"tnc",
        isPageCustom:true,
        isLoginRequired:false,
        component:TnCScreen
    },
    THREEC:{
        key:4,
        route:"3c",
        queryValue:"3c",
        isPageCustom:true,
        isLoginRequired:false,
        component:TnCScreen
    },
    HOMES:{
        key:5,
        route:"homes",
        queryValue:"homes",
        isPageCustom:true,
        isLoginRequired:false,
        component:TnCScreen
    },
    PROFILE:{
        key:6,
        route:"profile",
        queryValue:"profile",
        isPageCustom:false,
        isLoginRequired:true,
        component:Profile
    },
    HELP: {
        key: 8,
        route: 'help',
        queryValue: 'help',
        isPageCustom: false,
        isLoginRequired: true,
        component: Help,
    },
    FORM:{
        key: 8,
        route: 'form',
        queryValue: 'form',
        isPageCustom: false,
        isLoginRequired: false,
        component: FormScreenNew,
    },
    EARN:{
        key:9,
        route:'earn',
        queryValue:'earn',
        isPageCustom: false,
        isLoginRequired: true,
        component:Earn
    },
    LOGIN:{
        key:10,
        route:'login',
        queryValue:"landing",
        isPageCustom:false,
        isLoginRequired:false,
        component:LandingNew
    },
    ERROR:{
        key:11,
        isPageCustom:false,
        isLoginRequired:false,
        route:'error',
        queryValue:"master_franchise",
        component:NotFoundScreen
    },
    OYO_SAATHI: {
        key: 12,
        isPageCustom: false,
        isLoginRequired: false,
        route: 'oyosaathi',
        queryValue: 'oyosaathi',
        component: OyoSaathi,
    },

    STATIC: {
        key: 13,
        route: 'static',
        component: NotFoundScreen,
        childRoutes: [
            {
                route: 'mission-1000',
                component: Mission1000,
            },
            {
                route: 'staycation',
                component: Staycation,
            },
            {
                route: 'resources/case-studies',
                component: Casestudies,
            },
            {
                route: 'giveaway',
                component: Giveaway,
            },
            {
                route: 'referral-program',
                component: Referral,
            },
        ]
    },

    PROSPERITY: {
        key: 14,
        route: 'prosperity',
        component: PartnerProsperity,
    }

};
Object.freeze(pages);

export default pages

var routeToPage = {};

for (const [key, value] of Object.entries(pages)) {
    routeToPage[value['route'].split('/')[0]] = key
}

Object.freeze(routeToPage);

export var routeToPage;

var domRoutes = [];

Object.values(pages).forEach(page=> {
    if(!page.isPageCustom){
        Object.keys(allCountriesData).forEach(l => {
            if(page.isLoginRequired)domRoutes.push(<PrivateRoute exact path={buildUrl(true,l,page.route)} component={page.component}/>);
            else domRoutes.push(<PublicRoute exact path={buildUrl(true,l,page.route)} component={page.component}/>);
    
            if(page.childRoutes != null){
                page.childRoutes.forEach( childRoute => {
                    if(page.isLoginRequired) domRoutes.push(<PrivateRoute exact path={buildUrl(true,l,page.route,childRoute.route)} component={childRoute.component}/>);
                    else domRoutes.push(<PublicRoute exact path={buildUrl(true,l,page.route,childRoute.route)} component={childRoute.component}/>);
                    domRoutes.push(<PublicRoute exact path={buildUrl(true,l,page.route,childRoute.route,'*')} component={LandingNew}/>)
                })
            }else{
                domRoutes.push(<PublicRoute exact path={buildUrl(true,l,page.route,'*')} component={LandingNew}/>)
            }
            
        });
        if(page.childRoutes != null){
            page.childRoutes.forEach( childRoute => {
                if(page.isLoginRequired) domRoutes.push(<PrivateRoute exact path={buildUrl(true,page.route,childRoute.route)} component={childRoute.component}/>);
                else domRoutes.push(<PublicRoute exact path={buildUrl(true,page.route,childRoute.route)} component={childRoute.component}/>);
                domRoutes.push(<PublicRoute exact path={buildUrl(true,page.route,childRoute.route,'*')} component={LandingNew}/>);
            })
        }
    
        if(page.isLoginRequired) domRoutes.push(<PrivateRoute exact path={buildUrl(true,page.route)} component={page.component}/>);
        else domRoutes.push(<PublicRoute exact path={buildUrl(true,page.route)} component={page.component}/>);
        domRoutes.push(<PublicRoute exact path={buildUrl(true,page.route,'*')} component={LandingNew}/>);
        
        
        
    }
});
export var domRoutes;

export const DEFAULT_PAGE_KEY = 'LANDING';

export const ERROR_PAGE_KEY = 'ERROR';

export const getRouteForPage = (page,...subRoutes) => {
    let country_iso_code = getClientSideCountryCode();
    if(typeof page == 'object'){
        return buildUrl(true,country_iso_code,page.route,...subRoutes)
    }
    return buildUrl(true,country_iso_code,page,...subRoutes)
};
